module.exports = __webpack_public_path__ + "img/register.637c45c5.svg";